module.exports = __webpack_public_path__ + "static/media/plakat.66da0a4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/plakat.jpg
// module id = 553
// module chunks = 0